import { Button, HeadingText, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { mobileScreenSize } from '../../../utils/constants'


const Header = ({ windowWidth, sheetsStateSetter, showDeprecationWarning }) => {
  const handleAddNewEntriesClick = () => {
    if (typeof sheetsStateSetter !== 'function') {
      return;
    }

    sheetsStateSetter({ type: 'grant', value: true });
    sheetsStateSetter({ type: 'showDeprecatedWarning', value: showDeprecationWarning });
  };
  if (windowWidth <= mobileScreenSize) {
    return (
      <Fragment>
        <div className="tpp_top">
          <HeadingText size="lg">
            <Message id="thirdPartyPerm.heading" />
          </HeadingText>
        </div>
        <div className="helpTextDiv">
          <Message id="thirdPartyPerm.helpText1" />
          {/* <div> */}
          <Message id="thirdPartyPerm.helpText2" />
          <Link
            id="helpSheetsLink"
            data-pa-click="helpSheetsLink"
            onClick={() => sheetsStateSetter({ type: 'help', value: true })}
          >
            <Message id="thirdPartyPerm.thirdPartyPermissions" />
          </Link>
          {/* </div> */}
        </div>
        <Button
          className="tpp_addBtn mobile_addBtn"
          onClick={handleAddNewEntriesClick}
          id="addNewEntriesBtn"
          data-pa-click="addNewEntriesBtn"
        >
          <Message id="thirdPartyPerm.addApiUserButton" />
        </Button>
      </Fragment>
    )
  }
  return (
    <Fragment>
      <div className="tpp_top">
        <HeadingText size="lg">
          <Message id="thirdPartyPerm.heading" />
        </HeadingText>
        <Button
          className="tpp_addBtn"
          onClick={handleAddNewEntriesClick}
          id="addNewEntriesBtn"
          data-pa-click="addNewEntriesBtn"
        >
          <Message id="thirdPartyPerm.addApiUserButton" />
        </Button>
      </div>
      <div className="helpTextDiv">
        <Message id="thirdPartyPerm.helpText1" />
        {/* <div> */}
        <Message id="thirdPartyPerm.helpText2" />
        <Link
          id="helpSheetsLink"
          data-pa-click="helpSheetsLink"
          onClick={() => sheetsStateSetter({ type: 'help', value: true })}
        >
          <Message id="thirdPartyPerm.thirdPartyPermissions" />
        </Link>
        {/* </div> */}
      </div>
    </Fragment>
  )
}

Header.propTypes = {
  sheetsStateSetter: PropTypes.func,
  windowWidth: PropTypes.number,
  showDeprecationWarning: PropTypes.bool,
}

export default Header
